<template>
  <div id="header">
    <div @click="back" class="header">
      <i class="iconfont">&#xe604;</i>
    </div>
    <vue-data-loading :loading="loading" :completed="completed" :listens="['infinite-scroll']" :init-scroll="true" @infinite-scroll="infiniteScroll">
      <div class="content">
        <div class="detail" v-for="item in alist" :key="item.id">
          <div class="mess">
            <div class="mess_title">
              <p>{{item.way}}</p>
               <p class="time">{{item.time}}</p>
            </div>
            <p>{{item.money}}</p>
          </div>
          <div class="price">
            <p class="way">{{item.explain}}</p>
          </div>
          <div class="price" v-if="item.goods && item.goods !=''">
            <p class="way">{{item.goods}}</p>
          </div>
        </div>
      </div>
      <img class="empty" src="/static/img/mescroll-empty.png" v-show="show">
      <div slot="infinite-scroll-loading">loading...</div>
      <div slot="completed">没有更多记录了~</div>
    </vue-data-loading>
  </div>
</template>

<script>
// 引入上拉加载组件
import VueDataLoading from 'vue-data-loading'
export default {
  name: 'Account',
  props: {
    list: Array
  },
  components: {
    VueDataLoading // 注册VueDataLoading组件
  },
  data () {
    return {
      loading: false,
      completed: false,
      num: 1,
      size: 20,
      alist: [],
      show: false
    }
  },
  methods: {
    back () {
      this.$router.go(-1) // 返回上一层
    },
    fetchData () {
      this.loading = true
      this.getAccountInfo()
    },
    infiniteScroll () {
      this.fetchData()
      this.num++
    },
    getAccountInfo () {
      // 联网请求
      this.axios.get('/ApiMyFinancialList/GetList', {
        params: {
          num: this.num, // 页码
          size: this.size
        }
      }).then(this.getAccountInfoSucc)
        .catch(this.getAccountInfoFail)
    },
    getAccountInfoSucc (res) {
      res = res.data
      if (res.ret && res.data) {
        const data = res.data
        var newList = JSON.parse(data.accountList)
        if (this.num === 0) {
          this.completed = true
          this.loading = false
          this.show = true
        } else {
          this.alist = this.alist.concat(newList)
          if (newList.length < this.size) {
            this.completed = true
          }
          this.loading = false
        }
      }
      // console.log(newList)
    },
    getAccountInfoFail (err) {
      alert(err)
    }
  }
}
</script>

<style scoped>
.vue-data-loading >>>.loading-header{ display: none!important;}
#header{ min-height: 100%;}
.empty{ display: block; margin: 0 auto; width: 100%;}
.header{ padding: 10px 15px; padding-bottom: 5px; border-bottom: 1px solid #f2f2f2;}
.header a{ text-decoration: none; color: #333;}
.header .iconfont{ font-size: 25px;}
.detail{ display: flex; flex-direction: column; justify-content: space-between; padding: 10px 15px; border-bottom: 1px solid #f2f2f2;}
.detail p{ font-weight: bold; font-size: 14px; color: #000;}
.detail .way{ font-size: 13px; color: #b3b3b3; font-weight: normal;word-wrap:break-word}
.detail .time{margin-left: 10px; font-size: 13px; color: #b3b3b3; font-weight: normal;}
.detail .price p{ font-weight: normal;}
.detail .add{ color: #ff6700;}
.detail .mess,.detail .price{ display: flex; justify-content: space-between;}
.detail .mess p:last-child{ font-weight: normal;}
.mess_title{display: flex;}
.detail .price{margin-top: 6px;}
</style>



// WEBPACK FOOTER //
// src/pages/account_record/components/Account.vue